module.exports = __webpack_public_path__ + "static/img/wuliu.6cd2a00.png";


//////////////////
// WEBPACK FOOTER
// ./static/imgs/wuliu.png
// module id = +Jd9
// module chunks = 4